import { Stack } from "@mui/material";
import ScanOnSite from "components/customer-information/preferences/scan-on-site/ScanOnSite";

import { PageTitle } from "components/shared";
import { t } from "i18next";

const ScanOnSiteScreen = () => {
  return (
    <>
      <Stack>
        <PageTitle title={`${t("preferences.detailsTitle")}`} />
        <ScanOnSite />
      </Stack>
    </>
  );
};

export default ScanOnSiteScreen;
